import React, { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * 페이지 전환 애니메이션 래퍼
 */
export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <div className="page-transition">
      {children}
    </div>
  );
};

/**
 * 페이드 인 페이지
 */
export const FadeInPage: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <div className="animate-fadeIn">
      {children}
    </div>
  );
};

/**
 * 슬라이드 인 페이지 (아래→위)
 */
export const SlideUpPage: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <div className="animate-slideUp">
      {children}
    </div>
  );
};

/**
 * 슬라이드 인 페이지 (오른쪽→왼쪽)
 */
export const SlideLeftPage: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <div className="animate-slideLeft">
      {children}
    </div>
  );
};
